module.exports = __webpack_public_path__ + "f0b75f75548f6e895cb62a02b1bee0f1.svg";